export const usedFonts = [
  { name: 'Times New Roman', jspdfName: 'times' },
  { name: 'Courier New', jspdfName: 'courier' },
  { name: 'Arial', jspdfName: 'helvetica' }, // Arial is the same as Helvetica
];
